var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkoutClearedStampSelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Self-declared graduation completion stamp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Orange circular informal stamp with a speech bubble, star, and large completion check.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#D97724",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 112,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 99,
    strokeWidth: 3,
    strokeDasharray: "8 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 44h68a14 14 0 0 1 14 14v30a14 14 0 0 1-14 14h-31l-18 15 3-15H94a14 14 0 0 1-14-14V58a14 14 0 0 1 14-14Z",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 55 5 11 12 1-9 8 3 12-11-6-11 6 3-12-9-8 12-1 5-11Z",
    fill: "#D97724",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68 143 41 41 79-79",
    strokeWidth: 17,
    transform: "translate(38.4 38.4) scale(.7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutClearedStampSelf);
export default __webpack_public_path__ + "static/media/workout_cleared_stamp_self.37ec551228d58432ba84fd020bdf63ed.svg";
export { ForwardRef as ReactComponent };